export const translations = {
  it: {
    nav: {
      suite: "L'Appartamento",
      gallery: "Galleria",
      availability: "Disponibilità",
      loano: "Loano",
      reviews: "Recensioni",
      about: "Chi siamo",
      book: "Prenota ora",
    },
    hero: {
      overline: "Liguria · Riviera delle Palme",
      title: "Un appartamento affacciato\nsul mare.",
      subtitle:
        "AMAC Suites · Via Donizetti 9, Loano. Affitto breve curato nei minimi dettagli, a pochi passi dal mare.",
      cta: "Verifica disponibilità",
      secondary: "Scopri l'appartamento",
    },
    highlights: {
      overline: "L'Appartamento",
      title: "Un bilocale elegante con terrazzo, a due passi dal mare.",
      welcome:
        "AMAC Suites è un bilocale di 50 m² pensato per chi viaggia con gusto: una camera matrimoniale, un soggiorno con angolo cottura e un terrazzo dove fare colazione al sole della Liguria. A soli 6 minuti a piedi dalla spiaggia, vicinissimo al centro e alla stazione, ma in una zona così silenziosa che il treno non si sente.",
      items: [
        { label: "Posizione", value: "Via Donizetti 9 · Loano (SV)" },
        { label: "Spiaggia", value: "6 min a piedi" },
        { label: "Tipologia", value: "Bilocale · 1 camera + soggiorno" },
        { label: "Superficie", value: "50 m² + terrazzo" },
        { label: "Ospiti", value: "Fino a 6 ospiti" },
        { label: "Parcheggio", value: "Disponibile nel cortile" },
      ],
    },
    about: {
      overline: "Benvenuti",
      title: "Un bilocale luminoso con terrazzo, a pochi passi dal mare.",
      body: [
        "AMAC Suites è un bilocale di 50 m² pensato per chi viaggia con gusto: una camera matrimoniale, un soggiorno con angolo cottura e un terrazzo dove fare colazione al sole della Liguria.",
        "Via Donizetti 9 si trova nel cuore della zona residenziale di Loano, a cinque minuti a piedi dal lungomare e dal centro storico. Comodissimo parcheggio nel cortile interno, spiaggia, ristoranti e stazione tutti raggiungibili a piedi.",
      ],
    },
    gallery: {
      overline: "Galleria",
      title: "Gli interni.",
      subtitle: "Materiali naturali, palette tenue, luce ligure.",
    },
    amenities: {
      overline: "Dotazioni",
      title: "Tutto ciò che ti serve, già pronto per te.",
      subtitle:
        "L'appartamento è fornito di tutto il necessario per un soggiorno senza pensieri.",
      groups: [
        {
          title: "Comfort & biancheria",
          items: [
            "Climatizzazione (aria condizionata)",
            "Lenzuola e biancheria da bagno",
            "Prodotti per le pulizie",
            "Giochi per i bambini",
          ],
        },
        {
          title: "Elettrodomestici",
          items: [
            "Lavastoviglie",
            "Lavatrice",
            "Friggitrice ad aria",
            "Microonde",
            "Macchina per il caffè",
            "Tostapane",
            "Aspirapolvere",
          ],
        },
        {
          title: "Cucina",
          items: [
            "Cucina a induzione",
            "Stoviglie, posate e bicchieri completi",
            "Pentole, padelle e utensili",
            "Moka e bollitore",
          ],
        },
      ],
    },
    rates: {
      overline: "Tariffe stagionali",
      title: "Prezzi trasparenti, per notte.",
      note: "I prezzi includono biancheria, pulizia finale e Wi‑Fi. Tassa di soggiorno non inclusa.",
      perNight: "/ notte",
      minNights: "soggiorno minimo",
      nights: "notti",
    },
    availability: {
      overline: "Disponibilità",
      title: "Scegli le tue date.",
      subtitle:
        "Le date in rosso sono già prenotate. Seleziona check‑in e check‑out per inviare una richiesta.",
      legendAvailable: "Disponibile",
      legendBooked: "Prenotato",
      legendSelected: "Selezionate",
      selectedRange: "Date selezionate",
      clear: "Cancella",
    },
    booking: {
      overline: "Richiesta di prenotazione",
      title: "Scrivici, ti risponderemo entro 24 ore.",
      name: "Nome e cognome",
      email: "Email",
      phone: "Telefono",
      checkIn: "Check‑in",
      checkOut: "Check‑out",
      guests: "Ospiti",
      adults: "Adulti",
      adultsHint: "dai 16 anni",
      children: "Bambini",
      childrenHint: "0–16 anni",
      childAge: "Età bambino",
      years: "anni",
      message: "Messaggio",
      messagePlaceholder: "Raccontaci di te e delle tue date ideali…",
      submit: "Invia richiesta",
      sending: "Invio in corso…",
      successTitle: "Richiesta inviata!",
      successBody: "Ti risponderemo a breve via email.",
      errorTitle: "Qualcosa è andato storto",
      errorBody: "Riprova tra qualche minuto o scrivici direttamente.",
      pickDates: "Seleziona prima le date nel calendario",
      disclaimer:
        "Questa non è una prenotazione confermata, ma solo una richiesta di disponibilità. Ti risponderemo entro 24 ore via email per confermare le date e i dettagli del soggiorno. Per prenotare si chiede sempre circa 20-30% di acconto e il saldo deve avvenire entro 7 giorni prima del check‑in. Modalità di pagamento: bonifico, carta, Satispay o Revolut.",
    },
    loano: {
      overline: "Cosa fare a Loano",
      title: "La Riviera, a portata di mano.",
      items: [
        {
          title: "Spiagge",
          body:
            "Spiaggia più vicina a pagamento: Tiki Beach. In alternativa, ampia spiaggia libera a pochi passi. Sabbia fine e acqua trasparente, tutto a 5 minuti a piedi.",
        },
        {
          title: "Borgo storico",
          body:
            "Vicoli medievali, il Palazzo Doria e una passeggiata lungomare che porta fino al porto turistico.",
        },
        {
          title: "Sapori liguri",
          body:
            "Trattorie di pesce, focaccia calda e farinata. I migliori indirizzi del paese, a piedi.",
        },
        {
          title: "Outdoor",
          body:
            "Sentieri sulla Rocca, percorsi MTB tra gli ulivi e diving lungo la costa.",
        },
      ],
    },
    reviews: {
      overline: "Recensioni",
      title: "Le voci dei nostri ospiti.",
    },
    map: {
      overline: "Posizione",
      title: "Via Donizetti 9, Loano (SV).",
      cta: "Apri in Google Maps",
    },
    footer: {
      tagline: "La tua unica vacanza senza pensieri.",
      contact: "Contatti",
      address: "Via Donizetti 9 · 17025 Loano (SV) · Italia",
      rights: "Tutti i diritti riservati.",
    },
    about: {
      overline: "Chi siamo",
      title: "Benvenuti a Loano.",
      kicker: "",
      intro:
        "Ci presentiamo: siamo Aida e Matteo, proprietari e gestori di questo appartamento.",
      paragraphs: [
        "Aida, originaria di Trieste, è responsabile di comunicazione e marketing per un'azienda di Alba (CN) che da anni gestisce un residence nella stessa area. Matteo è un ingegnere meccanico, appassionato di fai‑da‑te e sempre attento a migliorare ogni dettaglio della casa.",
        "Questo appartamento è il frutto di impegno, sacrifici e di un grande amore per Loano. Acquistato e rinnovato tra aprile e maggio 2026, viene migliorato continuamente per offrire un ambiente sempre più accogliente.",
        "Ci auguriamo che possiate sentirvi come a casa, rilassarvi e godervi il mare, i colori e l'atmosfera della splendida Loano.",
      ],
      signature: "Aida e Matteo",
      cities: "Govone · Loano · Trieste",
      backHome: "← Torna alla home",
    },
  },
  en: {
    nav: {
      suite: "The Apartment",
      gallery: "Gallery",
      availability: "Availability",
      loano: "Loano",
      reviews: "Reviews",
      about: "About us",
      book: "Book now",
    },
    hero: {
      overline: "Liguria · Italian Riviera",
      title: "An apartment facing\nthe sea.",
      subtitle:
        "AMAC Suites · Via Donizetti 9, Loano. A short‑let crafted with care, steps from the sea.",
      cta: "Check availability",
      secondary: "Discover the home",
    },
    highlights: {
      overline: "The Apartment",
      title: "An elegant one‑bedroom with terrace, steps from the sea.",
      welcome:
        "AMAC Suites is a 50 sqm one‑bedroom for travellers with taste: a double bedroom, a living room with kitchenette and a terrace where you can have breakfast in the Ligurian sun. Just 6 minutes on foot from the beach, very close to the town centre and train station — yet so quiet you won't hear the trains.",
      items: [
        { label: "Location", value: "Via Donizetti 9 · Loano (SV)" },
        { label: "Beach", value: "6 min on foot" },
        { label: "Layout", value: "1 bedroom + living room" },
        { label: "Size", value: "50 sqm + terrace" },
        { label: "Guests", value: "Up to 6 guests" },
        { label: "Parking", value: "Available in the courtyard" },
      ],
    },
    about: {
      overline: "Welcome",
      title: "A bright one‑bedroom apartment with terrace, steps from the sea.",
      body: [
        "AMAC Suites is a 50 sqm one‑bedroom for travellers with taste: a double bedroom, a living room with kitchenette and a terrace where you can have breakfast in the Ligurian sun.",
        "Via Donizetti 9 sits in Loano's quiet residential heart, a five‑minute walk from the seafront and the old town. Convenient parking in the inner courtyard; beach, restaurants and train station all on foot.",
      ],
    },
    gallery: {
      overline: "Gallery",
      title: "The interiors.",
      subtitle: "Natural materials, soft palette, Ligurian light.",
    },
    amenities: {
      overline: "What's included",
      title: "Everything you need, ready for you.",
      subtitle:
        "The apartment is equipped with everything you need for a worry‑free stay.",
      groups: [
        {
          title: "Comfort & linen",
          items: [
            "Air conditioning",
            "Bed and bath linen",
            "Cleaning products",
            "Toys & games for children",
          ],
        },
        {
          title: "Appliances",
          items: [
            "Dishwasher",
            "Washing machine",
            "Air fryer",
            "Microwave",
            "Coffee machine",
            "Toaster",
            "Vacuum cleaner",
          ],
        },
        {
          title: "Kitchen",
          items: [
            "Induction cooktop",
            "Full set of dishes, cutlery and glasses",
            "Pots, pans and utensils",
            "Moka pot and kettle",
          ],
        },
      ],
    },
    rates: {
      overline: "Seasonal rates",
      title: "Transparent pricing, per night.",
      note: "Includes linen, final cleaning and Wi‑Fi. City tax not included.",
      perNight: "/ night",
      minNights: "minimum stay",
      nights: "nights",
    },
    availability: {
      overline: "Availability",
      title: "Choose your dates.",
      subtitle:
        "Dates in red are already booked. Pick check‑in and check‑out to send a request.",
      legendAvailable: "Available",
      legendBooked: "Booked",
      legendSelected: "Selected",
      selectedRange: "Selected dates",
      clear: "Clear",
    },
    booking: {
      overline: "Booking request",
      title: "Send us a note — we reply within 24 hours.",
      name: "Full name",
      email: "Email",
      phone: "Phone",
      checkIn: "Check‑in",
      checkOut: "Check‑out",
      guests: "Guests",
      adults: "Adults",
      adultsHint: "16+ years",
      children: "Children",
      childrenHint: "0–16 years",
      childAge: "Child age",
      years: "years",
      message: "Message",
      messagePlaceholder: "Tell us about you and your ideal dates…",
      submit: "Send request",
      sending: "Sending…",
      successTitle: "Request sent!",
      successBody: "We'll get back to you shortly by email.",
      errorTitle: "Something went wrong",
      errorBody: "Please try again in a few minutes or email us directly.",
      pickDates: "Please pick dates in the calendar first",
      disclaimer:
        "This is not a confirmed booking but only an availability request. We'll get back to you within 24 hours by email to confirm your dates and stay details. To confirm a booking we always ask for a 20-30% deposit, and the balance must be paid within 7 days before check‑in. Payment methods: bank transfer, card, Satispay or Revolut.",
    },
    loano: {
      overline: "What to do in Loano",
      title: "The Riviera, at your doorstep.",
      items: [
        {
          title: "Beaches",
          body:
            "Nearest paid beach: Tiki Beach. Or wide free public beach just a few steps away. Fine sand and clear water, 5 minutes on foot.",
        },
        {
          title: "Old town",
          body:
            "Medieval alleys, Palazzo Doria, and a seafront promenade leading to the marina.",
        },
        {
          title: "Ligurian flavours",
          body:
            "Seafood trattorias, warm focaccia, farinata. The best local addresses, all walkable.",
        },
        {
          title: "Outdoors",
          body:
            "Hiking on the Rocca, MTB trails through olive groves and diving along the coast.",
        },
      ],
    },
    reviews: {
      overline: "Reviews",
      title: "What our guests say.",
    },
    map: {
      overline: "Location",
      title: "Via Donizetti 9, Loano (SV).",
      cta: "Open in Google Maps",
    },
    footer: {
      tagline: "Your perfect holiday without thoughts.",
      contact: "Contact",
      address: "Via Donizetti 9 · 17025 Loano (SV) · Italy",
      rights: "All rights reserved.",
    },
    about: {
      overline: "About us",
      title: "Welcome to Loano.",
      kicker: "",
      intro:
        "Let us introduce ourselves: we are Aida and Matteo, the owners and managers of this apartment.",
      paragraphs: [
        "Aida, originally from Trieste, works in communication and marketing for a company in the Alba area and has been managing another residence in the same region for several years. Matteo is a mechanical engineer, passionate about DIY projects and always focused on improving every detail of the house.",
        "This apartment is the result of dedication, hard work and a deep love for Loano. It was purchased and renovated between April and May 2026, with the goal of continuously improving it to offer our guests an increasingly welcoming environment.",
        "We hope you will feel at home, relax and enjoy the sea, the colors and the atmosphere of beautiful Loano.",
      ],
      signature: "Aida and Matteo",
      cities: "Govone · Loano · Trieste",
      backHome: "← Back to home",
    },
  },
};
